import{FC, useMemo} from 'external/react'

import { searchInStrings } from 'utilities/text'
import { clsx } from 'external/clsx'

import { PackageUser } from 'types/context/package'

type SelectUserTableProps = {
	role: 'Student' | 'Tutor',
    onUserSelected: (user: PackageUser) => void,
    selectedUser: PackageUser | null,
    search: string,
    users: PackageUser[]
}

const SelectUserTable: FC<SelectUserTableProps> = props => {

	const {role, search, users, selectedUser, onUserSelected} = props

    const rolePlural = useMemo(() => role === 'Student' ? 'estudiantes' : 'tutores', [role])

	const filterUsers = useMemo(() => (({name}) => searchInStrings(search)(name)), [search])
	const filteredUsers = useMemo(() => users.filter(filterUsers) , [filterUsers, users])

    return (
            <table className='table table-bordered table-hover'>
                <tbody>
                {filteredUsers.map((user, index) => {
                    const selected = selectedUser?.id == user.id
                    const style = {cursor: selected ? 'default' : 'pointer'}
                    return (
                        <tr key={index}>
                                <td className={clsx('d-flex', 'p-0')}>
                                    <input className='mx-2 py-1' type='radio' style={style} name='status' value={user.id} checked={selected} id={'user_' + index} onChange={() => onUserSelected(user)} />
                                    <label className='py-1 ps-1 text-capitalize flex-grow-1' style={style} htmlFor={'user_' + index}>
                                        {user.name}
                                    </label>
                                </td>
                            </tr>
                    )})}
                    {filteredUsers.length === 0 && ( <tr><td>No se encontraron {rolePlural}</td></tr>)}
                </tbody>
            </table>
	)

}

export {SelectUserTable as default}